var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.validation')) + "\n    "), _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": _vm.i18nt('designer.setting.validationHelp')
    }
  }, [_c('i', {
    staticClass: "el-icon-info"
  })])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: (_vm.optionModel.validation),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "validation", $$v)
      },
      expression: "optionModel.validation"
    }
  }, _vm._l((_vm.fieldValidators), function(fv, fvIdx) {
    return _c('el-option', {
      key: fvIdx,
      attrs: {
        "label": fv.label,
        "value": fv.value
      }
    })
  }), 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af4d54d2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/validation-editor.vue
// module id = null
// module chunks = 